// Checks to see if it's postseason o tiebreaker game
const getPostSeasonReady = (gameType, tiebreaker) => {
    const isPostSeason = (
        gameType === 'F' ||
        gameType === 'D' ||
        gameType === 'L' ||
        gameType === 'W' ||
        gameType === 'C'
    );

    const isTieBreaker = (tiebreaker && tiebreaker === 'Y') && gameType === 'R';

    return {
        isPostSeason,
        isTieBreaker,
        isPostSeasonReady: isPostSeason || isTieBreaker
    };
};

export const hasFreeGame = (broadcasts) => {
    let isFree = false
    for (let i = 0; i < broadcasts?.length; i++) {
        if (broadcasts[i]?.freeGame) {
            isFree = true;
            break;
        }
    };
    return isFree;
}

// Get an object with boolean values describing the status of a game using gameType, doubleHeader, status, flags, and broadcasts[i].freeGame.
const extendStatus = (statsapiGame = {}) => {
    const { gameType, tiebreaker, doubleHeader = 'N', status = {}, flags = {}, broadcasts } = statsapiGame;
    const { noHitter, perfectGame } = flags;
    let isFreeGame = false;

    if (broadcasts) {
        isFreeGame = hasFreeGame(broadcasts);
    }

    const { abstractGameCode, codedGameState, statusCode, startTimeTBD } = status;
    const isInGameDelay = (codedGameState === 'I' && (statusCode !== 'I' && statusCode !== 'IH'));
    const isPreGameDelay = (codedGameState === 'P' && (statusCode !== 'P' && statusCode !== 'PW'));
    const completedEarly = (codedGameState === 'F' &&
        (statusCode !== 'F' && statusCode !== 'FT' && statusCode !== 'FW'));
    const { isPostSeason, isTieBreaker, isPostSeasonReady } = getPostSeasonReady(gameType, tiebreaker);

    return {
        isAllStar: gameType === 'A',
        isCancelled: codedGameState === 'C',
        isClassicDoubleHeader: doubleHeader === 'Y',
        isCompletedEarly: completedEarly,
        isDelayed: (isInGameDelay || isPreGameDelay),
        isDoubleHeader: doubleHeader !== 'N',
        isExhibition: gameType === 'E',
        isFinal: abstractGameCode === 'F',
        isForfeit: (codedGameState === 'Q' || codedGameState === 'R'),
        isFreeGame: isFreeGame,
        isInstantReplay: statusCode === 'IH',
        isLive: abstractGameCode === 'L',
        isManagerChallenge: codedGameState === 'M',
        isNoHitter: !!noHitter,
        isPerfectGame: !!perfectGame,
        isPostponed: codedGameState === 'D',
        isPreview: abstractGameCode === 'P',
        isSplitTicketDoubleHeader: doubleHeader === 'S',
        isSpring: gameType === 'S',
        isSuspended: (codedGameState === 'T' || codedGameState === 'U'),
        isTBD: !!startTimeTBD,
        isUmpireReview: codedGameState === 'N',
        isWarmup: statusCode === 'PW',
        isPostSeason,
        isTieBreaker,
        isPostSeasonReady,
        isWildCard: gameType === 'F',
        isDivisionSeries: gameType === 'D',
        isChampionshipSeries: gameType === 'L',
        isWorldSeries: gameType === 'W',
        isPreGameDelay,
        isInGameDelay,
        isGameOver: statusCode === 'O'
    };
};

export default extendStatus;

